import * as React from 'react';
import Box from '@mui/material/Box';

interface IRecentSearchTileImgProps {
    alt: string;
    src: string;
    inventoryCount: number;
    handleOnLoad: () => void;
}

const RecentSearchTileImg = ({ alt, src, handleOnLoad }: IRecentSearchTileImgProps) => (
    <Box
        component="img"
        src={src}
        alt={alt}
        onLoad={handleOnLoad}
        sx={{
            width: 'calc(100% + 7rem)',
            transform: 'translate(-1rem,-2rem)',
        }}
        className="kmx-recent-search-tile-image"
    />
);

export default RecentSearchTileImg;
